module.exports = __webpack_public_path__ + "img/南方医院增城分院.4e9221a7.png";